var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 191.4 57",
    style: {
      enableBackground: "new 0 0 191.4 57"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.7,13.7c0,6,3.7,10.2,9.5,10.2c5.3,0,8.5-3,9-7.3H81c-0.4,2.8-2.4,4.8-5.7,4.8c-4,0-6.4-3.2-6.4-7.7 c0-4.4,2.4-7.7,6.4-7.7c3.3,0,5.2,2.1,5.7,4.9h3.2c-0.5-4.4-3.7-7.4-9-7.5C69.4,3.4,65.7,7.6,65.7,13.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.8,23.9c2.6,0,4-1.2,4.7-2.3c0,0.7,0.1,1.4,0.1,2h3c-0.2-1.1-0.3-2.5-0.3-3.5v-5.2c0-4.4-3.2-5.5-6-5.5 c-3.1,0-5.6,1.2-6.1,4.5h2.9c0.2-1.6,1.6-2.2,3.2-2.2c1.9,0,3.1,0.9,3.1,2.6v0.5l-2.6,0.1c-3.7,0.2-7.1,1-7.1,4.5 C85.7,22.2,87.8,23.9,90.8,23.9z M91.4,21.6c-1.7,0-2.8-0.9-2.8-2.2c0-1.9,2.5-2.4,4.9-2.5l2-0.1l0,0.8 C95.4,20.7,93.1,21.6,91.4,21.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M101.4,9.7v13.9h2.9v-6.3c0-4.3,2.4-5.1,4.1-5.1h1.1V9.6h-1.2c-1.8,0-3.2,0.8-4,2.8V9.7H101.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M124,17.5v-0.8c0-4.5-2.6-7.3-6.6-7.3c-4.2,0-6.8,2.9-6.8,7.2c0,4.3,2.8,7.2,6.9,7.2c3,0,5.7-1.4,6.3-4.7h-2.9 c-0.5,1.9-2.3,2.4-3.5,2.4c-2.4,0-3.7-1.7-3.8-4H124z M117.4,11.7c2.2,0,3.5,1.4,3.7,3.7h-7.6C113.7,13.2,115.1,11.7,117.4,11.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.8,32.2V52h14.5v-2.4H69.8v-6.4h10.5v-2.4H69.8v-6h11.5v-2.4H66.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.6,38.1L87.5,52h3.6l5-13.9h-3.1l-3.7,11.3l-3.7-11.3H82.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104,52.2c4.1,0,6.9-2.8,6.9-7.2c0-4.4-2.8-7.2-6.9-7.2c-4.1,0-6.9,2.8-6.9,7.2C97.1,49.4,99.9,52.2,104,52.2z  M104,49.9c-2.5,0-3.9-2.1-3.9-4.9c0-2.8,1.4-4.9,3.9-4.9s3.9,2,3.9,4.9C107.9,47.9,106.5,49.9,104,49.9z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M113.6,32.2V52h2.9V32.2H113.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M132.4,52V38.1h-2.9v7.8c0,2.7-1.6,4.2-3.5,4.2c-1.5,0-3-0.8-3-3.9v-8h-2.9v8.4c0,4.4,2.7,5.8,5.1,5.8 c2,0,3.5-0.9,4.3-2.3l0,2H132.4z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M140.3,52h3.3v-2.4h-2.2c-1.1,0-1.6-0.5-1.6-1.8v-7.5h3.7v-2.3h-3.7v-3.9H137v3.9h-2.4v2.3h2.4v8 C137,50.7,138.4,52,140.3,52z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M145.8,32.5v2.8h3.5v-2.8H145.8z M146.1,38.1V52h2.9V38.1H146.1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M158.6,52.2c4.1,0,6.9-2.8,6.9-7.2c0-4.4-2.8-7.2-6.9-7.2c-4.1,0-6.9,2.8-6.9,7.2 C151.7,49.4,154.5,52.2,158.6,52.2z M158.6,49.9c-2.5,0-3.9-2.1-3.9-4.9c0-2.8,1.4-4.9,3.9-4.9c2.5,0,3.9,2,3.9,4.9 C162.6,47.9,161.1,49.9,158.6,49.9z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M168.3,38.1V52h2.9v-7.8c0-2.7,1.6-4.2,3.5-4.2c1.5,0,3,0.8,3,3.9v8h2.9v-8.4c0-4.4-2.7-5.8-5.1-5.8 c-2,0-3.5,0.9-4.3,2.3l-0.1-2H168.3z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.4,7.1l13.4,13.4c-1.1,0.7-2,1.6-2.7,2.7h0L7.7,9.7L10.4,7.1z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.8,36.6L10.4,49.9l-2.7-2.7l13.4-13.4C21.8,34.9,22.7,35.9,23.8,36.6z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20,1.5L27.3,19c-1.3,0.2-2.5,0.8-3.5,1.4L16.5,3L20,1.5z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.1,0.1V19c-0.6-0.1-1.2-0.2-1.9-0.2c-0.6,0-1.3,0.1-1.9,0.2V0.1H31.1z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.8,36.6c1,0.7,2.2,1.2,3.5,1.4L20,55.5L16.5,54L23.8,36.6z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.2,38.2c0.6,0,1.3-0.1,1.9-0.2v18.9h-3.8V38C27.9,38.1,28.5,38.2,29.2,38.2z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.2,33.9C37.2,33.9,37.2,33.9,37.2,33.9l13.4,13.4l-2.7,2.7L34.6,36.6C35.6,35.9,36.5,34.9,37.2,33.9 L37.2,33.9z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.6,9.7L37.2,23.1l0,0c-0.7-1.1-1.6-2-2.7-2.7L47.9,7.1L50.6,9.7z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.8,3l-7.2,17.5c-1-0.7-2.2-1.2-3.5-1.4l7.2-17.5L41.8,3z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.1,38c1.3-0.2,2.5-0.8,3.5-1.4L41.8,54l-3.5,1.4L31.1,38z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.2,37.6l17.5-7.2c0.3,1.3,0.8,2.5,1.4,3.5L3.6,41.1L2.2,37.6z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.6,15.9l17.5,7.2c-0.7,1-1.2,2.2-1.4,3.5L2.2,19.4L3.6,15.9z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.8,26.6h18.9c-0.1,0.6-0.2,1.2-0.2,1.9s0.1,1.3,0.2,1.9H0.8V26.6z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M185.2,40.7v-2.5h-1v-0.5h2.5v0.5h-1v2.5H185.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M187.1,40.7v-3h0.6l0.9,2.4l0.9-2.4h0.6v3h-0.4v-2.2l-0.8,2.2h-0.5l-0.8-2.2v2.2H187.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCeLogo);
export default __webpack_public_path__ + "static/media/ce-logo.e0871978a217a22be28d10c3de4fe384.svg";
export { ForwardRef as ReactComponent };